module.exports = __webpack_public_path__ + "img/95.472675d3.jpg";